import { t } from 'i18next';

export const DEFAULT_TIME_SELECTION = {
  name: t('SelectTimeDispatch:defaultTimeOption'),
  value: -1
};

export const MAX_HOURS = 24;
export const SCHEDULE_TIME = 'scheduleTime';
export const AS_SOON_AS_POSSIBLE = 'asSoonAsPossible';
export const MINUTES_PER_HOUR = 60;
